import './RAAccordionStep.scss';
// @ vendors
import React from 'react';
import PropTypes from 'prop-types';
// @ components
import { RAAccordion } from 'components/RAComponents/commons/RAAccordion/RAAccordion';
import { RAAccordionRow } from 'components/RAComponents/commons/RAAccordion/RAAccordionRow/RAAccordionRow';
import { InfoTooltip } from 'components/tooltip/tooltip';
// @ utilities
import { formatText } from 'core/i18n';
// @ constants
import { EVENT_DETAIL_TOOLTIP } from 'constants/uTagConstants/RAConstants';

export const RAAccordionStep = ({
    expandAccordionRow,
    expandedRowId,
    formActions,
    immAnswers,
    profileModel,
    rows,
    selectAccordionButton,
    subtitle,
    title,
    userProfile,
    validateStep,
    onClickTooltip,
    recordEvent,
}) => {
    return (
        <section className="ra-accordion-step">
            <div className="ra-accordion-step__header">
                <span className="ra-accordion-step__title">
                    {title}
                    <div
                        className="ra-accordion-step__tooltip-wrapper"
                        onClick={() => onClickTooltip(EVENT_DETAIL_TOOLTIP)}
                    >
                        <InfoTooltip text={formatText('investmentExperience-tooltip')} />
                    </div>
                </span>{' '}
                <span className="ra-accordion-step__subtitle">{subtitle}</span>
            </div>
            <RAAccordion>
                {rows.map((row, index) => {
                    const selectedOption = immAnswers.get(row.id);

                    return (
                        <RAAccordionRow
                            expandAccordionRow={expandAccordionRow}
                            expandedRowId={expandedRowId}
                            formActions={formActions}
                            key={row.id}
                            profileModel={profileModel}
                            row={row}
                            rowIndex={index}
                            selectAccordionButton={selectAccordionButton}
                            selectedOption={selectedOption}
                            userProfile={userProfile}
                            validateStep={validateStep}
                            recordEvent={recordEvent}
                        />
                    );
                })}
            </RAAccordion>
        </section>
    );
};

RAAccordionStep.propTypes = {
    expandAccordionRow: PropTypes.func.isRequired,
    expandedRowId: PropTypes.string,
    formActions: PropTypes.object.isRequired,
    immAnswers: PropTypes.object.isRequired,
    profileModel: PropTypes.string.isRequired,
    rows: PropTypes.array.isRequired,
    selectAccordionButton: PropTypes.func.isRequired,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    userProfile: PropTypes.object.isRequired,
    validateStep: PropTypes.func,
    onClickTooltip: PropTypes.func,
    recordEvent: PropTypes.func,
};
